import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

type Props = {
  onOk: () => void;
  customClass?: string|undefined,
};

const OkButton: React.FC<Props> = ({ onOk, customClass = undefined }) => {
  const okRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (okRef && okRef.current) {
      okRef.current.focus();
    }
  }, []);

  function onEnter(e:React.KeyboardEvent<HTMLElement>) {
    if (document.activeElement === okRef.current) {
      onOk();
      e.stopPropagation();
      e.preventDefault();
    }
  }

  function onKeyDown(e:React.KeyboardEvent<HTMLElement>) {
    switch (e.key) {
      case 'Enter': case ' ':
        onEnter(e);
          break;
      default:
        break;
    }
  }

  const classNames = customClass ? `ifms-primary-inverse-button ifms-focusable-inverse ${customClass}` : 'ifms-primary-inverse-button ifms-focusable-inverse';

  return (
    <>
    <div className="float-right">
      <button name ='ifms-dialog-button-ok'className={classNames} onClick={onOk} ref={okRef} onKeyDown={onKeyDown}>
        Ok
      </button>
    </div>
    <div className="clearfix"></div>
    </>
  );
};

OkButton.defaultProps = {
  onOk: () => {},
};

OkButton.propTypes = {
  onOk: PropTypes.func.isRequired,
  customClass: PropTypes.string,
};

export default React.memo(OkButton);
